import React from "react";
import {
  Button,
  Card,
  CardHeader,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Form,
} from "reactstrap";
import {
  getPayoutReqResLogs,
  usePayoutReqResLogs,
} from "../../../redux/slices/payoutReqResLogsSlice";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useState, useMemo } from "react";

import { useForm } from "react-hook-form";
import { Table, TableRow } from "../../../components/Table";
import {
  TRA_FILTER,
  SUPPORT_LOG_LOCAL,
  TRA_PAGINATION_OPTIONS,
} from "../../../constant";
import { Switch } from "@mui/material";
import { IoFilterOutline } from "react-icons/io5";
import {
  getLocalData,
  responseToaster,
  setLocalData,
} from "../../../helperFunctions";
import ControlledInput from "../../../components/Custom/Forms/Controller/ControlledInput";
import PayoutReqResLogsModal from "../../../components/Custom/Modals/PayoutReqResLogsModal/PayoutReqResLogsModal";
import "./PayoutReqResLogs.scss";
import { useRole } from "../../../redux/slices/authSlice";
import { useParams } from "react-router-dom";
import StatusCheckModal from "../../../components/Custom/Modals/PayoutReqResLogsModal/StatusCheckModal";

const PayoutReqResLogs = () => {
  const { id } = useParams();
  const initialValues = {
    isFilter: !!id || false,
    searchdata: id || "",
  };
  const [filter, setFilter] = useState({ ...TRA_FILTER, ...initialValues });
  const [filterColumns, setFilterColumns] = useState([]);
  const { isLoading } = useSelector((state) => state.payoutReqResLogs);
  const { payoutReqResLogsState } = usePayoutReqResLogs();
  const [data, setData] = useState({});
  const [isViewsendDataModal, setIsViewsendDataModal] = useState(false);
  const [statusCheckModal, setStatusCheckModal] = useState(false)

  const dispatch = useDispatch();
  const role = useRole("Payout Req Res Logs");

  const [isOpen, setIsOpen] = useState(false);
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleModal = (data) => {
    setData(data);
    setIsViewsendDataModal(!isViewsendDataModal);
  };

  const columns = useMemo(
    () => [
      {
        title: "ID",
        name: "payout_id",
      },
      {
        title: "REQUEST METHOD",
        name: "request_method",
      },
      {
        title: "REQUEST URL",
        name: "request_url",
      },

      {
        title: "SECONDS",
        name: "seconds ",
        Cell: (data) => {
          return (
            <>
              <span>{data?.seconds || ""}</span>
            </>
          );
        },
      },
      {
        title: "RESPONSE HTTP CODE",
        name: "response_http_code ",
        Cell: (data) => {
          return (
            <>
              <span
                className={
                  data?.response_http_code > 200
                    ? "badge badge-danger"
                    : "badge badge-success"
                }
              >
                {data?.response_http_code || ""}
              </span>
            </>
          );
        },
      },
      {
        title: "CREATED AT",
        name: "created_at",
      },
      {
        title: "DETAILS",
        name: "success_txn_per",
        Cell: (data) => {
          return (
            <div className="d-flex button-space align-items-center">
              <Button
                color="primary"
                className="btn-smallsize"
                style={{ backgroundColor: "var(--chatlook-darkblue--)" }}
                onClick={() => handleModal(data)}
              >
                Details
              </Button>
              <Button
                color="primary"
                className="btn-smallsize"
                style={{ backgroundColor: "var(--chatlook-darkblue--)" }}
                onClick={() => setStatusCheckModal({ data })}
              >
                Check status
              </Button>
            </div>
          );
        },
      },
    ],
    []
  );

  const GetPayoutReqResLogs = async () => {
    try {
      const { isFilter, page_no, limit, date, searchdata, ...rest } = filter;
      const payload = isFilter
        ? {
          filter_data: {
            searchdata,
            ...rest,
          },
          page_no,
          limit,
        }
        : {
          page_no,
          limit,
        };
      const res = await dispatch(getPayoutReqResLogs(payload)).unwrap();
      if (isFilter) {
        responseToaster(res);
      }
    } catch (err) { }
  };

  useEffect(() => {
    const newColumns = columns?.map((item) => item?.name);
    setFilterColumns(newColumns);
  }, []);

  useEffect(() => {
    if (role.includes("payoutReqResponse-list")) {
      GetPayoutReqResLogs();
    }
  }, [filter]);

  const onSubmit = async () => {
    const values = getValues();
    setFilter({
      ...filter,
      ...values,
      ...TRA_FILTER,
      isFilter: true,
    });
  };

  const { control, getValues, handleSubmit, setValue, reset } = useForm({
    defaultValues: initialValues,
  });

  useEffect(() => {
    if (id) {
      setValue("searchdata", id)
    }
  }, [id])

  const [isFilterOpen, setIsFilterOpen] = useState(
    getLocalData(SUPPORT_LOG_LOCAL, false)
  );
  const toggleIsFilterOpen = () => {
    setIsFilterOpen(!isFilterOpen);
    setLocalData(SUPPORT_LOG_LOCAL, !isFilterOpen);
  };

  return (
    <>
      {role.includes("payoutReqResponse-list") ? (
        <>
          <div className="payoutReqResLogs-log-main-div">
            <Card>
              <CardHeader className="flex-column  align-items-start">
                <div className="d-flex align-items-center w-100 justify-content-between">
                  <div>
                    <h4 className="main-title">
                      <b>Payout Req Res Logs</b>
                    </h4>
                  </div>

                  <div className="d-flex">
                    <Button
                      type="button"
                      className="filterbtn me-1"
                      onClick={toggleIsFilterOpen}
                    >
                      <i className="fa-solid fa-filter"></i> Apply Filter
                    </Button>
                    <Dropdown isOpen={isOpen} toggle={toggleDropdown}>
                      <DropdownToggle
                        className=" header-item waves-effect border-0 bg-transparent table-filterbtn"
                        id="page-header-user-dropdown"
                        tag="button"
                      >
                        <IoFilterOutline fill="#7367F0" />
                      </DropdownToggle>
                      <DropdownMenu
                        className="z-3"
                        style={{
                          whiteSpace: "nowrap",
                          padding: 20,
                          transform: "translate(-20px, 22px)",
                        }}
                      >
                        <li className="z-3 text-dark">
                          <span>
                            <i className="fa-solid fa-filter"></i> Filter Column
                          </span>
                        </li>
                        <div className="border-bottom border-light mt-2">
                          {columns?.map((column) => {
                            return (
                              <div className="d-flex justify-content-between">
                                <p>{column?.title}</p>
                                <Switch
                                  checked={filterColumns?.includes(
                                    column?.name
                                  )}
                                  size="small"
                                  onChange={(e) => {
                                    const newData = [...filterColumns];
                                    const index = newData?.indexOf(
                                      column?.name
                                    );
                                    if (index > -1) {
                                      newData.splice(index, 1);
                                    } else {
                                      newData.push(column?.name);
                                    }
                                    setFilterColumns(newData);
                                  }}
                                />
                              </div>
                            );
                          })}
                        </div>
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                </div>

                <Form
                  className="d-flex my-xl-auto right-content align-items-end button-space"
                  style={{ flexWrap: "wrap" }}
                  onSubmit={handleSubmit(onSubmit)}
                >
                  {isFilterOpen && (
                    <>
                      <ControlledInput
                        placeholder="Search by Payout Id"
                        name="searchdata"
                        label="Search"
                        disabled={!!id}
                        control={control}
                      />
                      <Button type="submit" color="primary">
                        Apply
                      </Button>
                      <Button
                        type="button"
                        color="danger"
                        onClick={() => {
                          reset();
                          setFilter({ ...TRA_FILTER, ...initialValues });
                        }}
                      >
                        Clear
                      </Button>
                    </>
                  )}
                </Form>
              </CardHeader>
              <Table
                columns={columns}
                isLoading={isLoading}
                data={payoutReqResLogsState?.data || []}
                isData={!!payoutReqResLogsState?.data?.length}
                filterColumns={filterColumns}
                count={payoutReqResLogsState?.total_item || 0}
                pagination={filter}
                isExpandable={false}
                handlePaginationChange={(pagination) => {
                  setFilter({
                    ...filter,
                    ...pagination,
                  });
                }}
                onColumnsChange={(columns) => {
                  setFilterColumns(columns);
                }}
                paginationOptions={TRA_PAGINATION_OPTIONS}
              >
                {payoutReqResLogsState?.data?.map((item) => {
                  return (
                    <TableRow
                      columns={columns}
                      item={item}
                      filterColumns={filterColumns}
                      isExpandable={false}
                    />
                  );
                })}
              </Table>
            </Card>
            <PayoutReqResLogsModal
              data={data}
              isViewsendDataModal={isViewsendDataModal}
              onCloseModal={() => handleModal()}
            />
             <StatusCheckModal
              isOpen={statusCheckModal}
              onCloseModal={() => setStatusCheckModal(false)}
            />
          </div>
        </>
      ) : null}
    </>
  );
};

export default PayoutReqResLogs;
